import { ButtonTheme, ButtonVariant } from '@/ts/Button'

const COLORS: Colors = {
  flat: {
    gray:
      'bg-sbtgray-100 text-sbtgray-600 hover:bg-sbtgray-200 active:bg-sbtgray-200',
    violet: 'bg-sbtviolet-150 text-sbtviolet-300',
    yellow: 'bg-yellow-5/25 text-yellow-70 hover:bg-yellow-5/50',
  },
  flat_solid_alt: {
    violet: 'text-sbtviolet-550 hover:bg-sbtviolet-100',
  },
  plain: {
    violet: 'text-sbtviolet-300 hover:text-sbtviolet-700',
  },
  plain_solid: {
    white: 'text-white hover:text-white/80',
    black: 'text-black hover:text-black/60',
    violet: 'text-sbtviolet-550 hover:text-sbtviolet-300',
  },
  rounded: {
    gray:
      'bg-sbtgray-100 text-sbtgray-600 hover:bg-sbtgray-200 active:bg-sbtgray-200',
    red:
      'bg-sbtred-100 text-sbtred-600 hover:bg-sbtred-200 active:bg-sbtred-400',
    violet:
      'bg-sbtviolet-100 text-sbtviolet-550 hover:bg-sbtviolet-200/100 active:bg-sbtviolet-300',
  },
  rounded_solid: {
    black: 'bg-black/80 hover:bg-black/100 text-white active:bg-black/60',
    blue:
      'bg-sbtblue-600 hover:bg-sbtblue-700 active:bg-sbtblue-400 text-white',
    violet:
      'bg-sbtviolet-550 hover:bg-sbtviolet-600 active:bg-sbtviolet-500 text-white',
  },
  rounded_outline: {
    violet:
      'border-sbtviolet-100 hover:bg-sbtviolet-100 active:bg-sbtviolet-200',
  },
}

type Colors = Record<
  ButtonVariant,
  Partial<Record<ButtonTheme, HTMLButtonElement['className']>>
>

export default COLORS
